import moment from "moment";
import React from "react";
import { useFormProduct } from "../../hooks/useFormProduct";
import { IProduct } from "../../views/ecommerce/products/interfaces";
import DropdownButton from "../DropdownButton";
import { DropdownItem } from "../DropdownButton/styles";
import { ITableContentListProducts } from "./interface"
import { Td, Tr } from "./style"

const TableContentListProducts = ({
    listProducts,
    setSelectedProduct,
    useForm
}: ITableContentListProducts) => {

    return (
        <>
            { 
                listProducts?.map((product: IProduct, index: number) => (
                    <Tr key={product.id}>
                        <Td>
                            {index + 1}
                        </Td>
                        <Td>
                            {product.nameProduct!}
                        </Td>
                        <Td>R$ {(parseInt(product.amount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Td>
                        <Td>{product.active ? "Ativado" : "Inativo"}</Td>
                        <Td>{moment(product.created_at).format("DD/MM/YYYY")}</Td>
                        <Td>{moment(product.updated_at).format("DD/MM/YYYY")}</Td>
                        <Td>
                            <DropdownButton 
                                isViewOptionVisible={true}
                                isAddImageOptionVisible={true}
                                isAddVarVisible={true}
                                isEditSecondaryOptionVisible={true}
                                setIsAddVarFormVisible={useForm.handlerFormAddDetail}
                                setIsAddImageVisible={useForm.handlerFormAddImage}
                                setIsEditFormSecondaryVisible={useForm.handlerFormEditDetail}
                                selectedUser={product}
                                setSelectedUser={setSelectedProduct}
                                modalId="#details-product"
                                openModal={true}
                            >
                                <DropdownItem className="dropdown-item" onClick={() => {
                                    setSelectedProduct(product)
                                    useForm.handlerFormEdit("open")
                                }}>
                                    Editar
                                </DropdownItem>
                            </DropdownButton>
                        </Td>
                    </Tr>
                ))
            }
        </>
    )
}

export default TableContentListProducts